import {
  CLEAR_DATE_TIME,
  DATES_LOADING_FAILED,
  DATES_LOADING_SUCCESS,
  SELECT_DAY,
  SELECT_SLOT,
  SELECT_TIME,
  SET_DEFAULT_VALUE,
} from "../actions/types";

const defaultState = {
  slots: null,
  error: null,
  selectedDay: null,
  selectedTime: null,
  selectedSlot: null,
};
const updateDates = (state, action) => {
  if (!state) {
    return defaultState;
  }

  switch (action.type) {
    case DATES_LOADING_SUCCESS:
      return {
        ...state.dates,
        slots: action.payload,
        error: null,
      };
    case DATES_LOADING_FAILED:
      return {
        ...state.dates,
        slots: null,
        error: action.payload.error,
      };
    case SELECT_DAY:
      return {
        ...state.dates,
        selectedDay: action.payload,
        selectedSlot: null,
      };
    case SELECT_TIME:
      return {
        ...state.dates,
        selectedTime: action.payload,
      };
    case SELECT_SLOT:
      return {
        ...state.dates,
        selectedSlot: action.payload,
      };
    case CLEAR_DATE_TIME:
      return {
        ...defaultState,
      };
    case SET_DEFAULT_VALUE:
      return {
        ...defaultState,
      };
    default:
      return {
        ...state.dates,
      };
  }
};

export default updateDates;
